import styled from "styled-components";

const StyledInput = styled.input`
  width: 100%;
`;

export default StyledInput;
